namespace advisorop.components.servicer {
    
    export class CuFirmProductTypesController {

        advisoryFirmId: number;
        managerId: number;
        reload: number;
        
        showProductTypePanel: boolean = false;
        dgFirmProductTypes: DevExpress.ui.dxDataGridOptions;

        managers: domains.IAdvisoryFirmManager[] = [];
        selManager: domains.IAdvisoryFirmManager;


        selProductType: domains.IAdvisoryFirmProductType;
        availableProductTypes: Array<domains.IManagerProductType> = [];
        firmProductTypes: Array<domains.IAdvisoryFirmProductType> = [];
        firmProductType: domains.IAdvisoryFirmProductType = {};

        // ????
        productTypeSelected: boolean = false;

        static $inject = ["servicerService", "generalService"];
        constructor(private servicerService: services.ServicerService,
            private generalService: services.GeneralService)
        {
            this.dgFirmProductTypes = {
                export: {
                    enabled: true,
                    fileName: "FirmProductTypes"
                },
                bindingOptions: {
                    dataSource: "vm.firmProductTypes"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no managers product types",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "managerName", caption: "Manager" },
                    { dataField: "productTypeName", caption: "Product Type" },
                    { dataField: "contactFirstName", caption: "First Name"},
                    { dataField: "contactLastName", caption: "Last Name"},
                    { dataField: "contactAddress", caption: "Address" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "110" }
                ]
            };
        }

        newManagerProductType(): void {
            this.selManager = null;
            this.selProductType = null;
            this.firmProductType = {};
            this.showProductTypePanel = true;
        };

        editFirmProductType(data: domains.IAdvisoryFirmProductType): void {
            if (data) {
                this.firmProductType = data;
                this.showProductTypePanel = true;
                // select manager 
                this.selManager = this.managers.filter(f => f.managerId == this.firmProductType.managerId)[0];
                // select product type
                if (this.selManager) {
                    this.loadAvailableProductTypes(this.selManager.managerId)
                        .then(data => {
                            this.selProductType = this.availableProductTypes.filter(f => f.id == this.firmProductType.managerProductTypeId)[0];
                        });
                }
                
            }
        };

        cancel(): void {
            this.selManager = null;
            this.selProductType = null;
            this.firmProductType = {};
            this.showProductTypePanel = false;
        };

        // #region Load methods

        // load managers for drop down
        loadAdvisoryFirmManagers(): void {
            this.servicerService.getFirmManagers(this.advisoryFirmId)
                .then(response => this.managers = response.data, err => toastr.error(err.data));
        };

        // load product types for selected manager ( drop down product type)
        loadAvailableProductTypes(managerId: number): ng.IPromise<any> {
            return this.servicerService.getManagerProductTypes(managerId)
                    .then(response => this.availableProductTypes = response.data,
                    err => toastr.error("Cannot fetch Product Types. " + err.data));
        };

        // loads assigned product type - manager for this firm
        loadFirmProductTypes(advisoryFirmId: number): void {
            this.servicerService.getAdvisoryFirmProductTypesByFirm(advisoryFirmId)
                .then(response => this.firmProductTypes = response.data,
                err => toastr.error("Cannot fetch Product Types. " + err.data));
        };

        // #endregion Load methods

        managerChanged(): void {
            if (this.selManager && this.selManager.id > 0) {
                this.loadAvailableProductTypes(this.selManager.managerId);
            }
        };

        productTypeChanged(): void {
            this.firmProductType.productTypeId = this.selProductType.productTypeId;
            //this.productTypeSelected = true;
        }
        
        // #region Product type CRUD

        addFirmProductType(): void {

            this.firmProductType.managerProductTypeId = this.selProductType.id;
            this.firmProductType.advisoryFirmId = this.advisoryFirmId;
            this.firmProductType.managerId = this.selManager.managerId;

            if (!this.chechForDuplicateProductTypes(this.firmProductType)) {
                this.servicerService.assignFirmProductType(this.firmProductType)
                    .then(response => {
                        toastr.success("Product Type has been successfully assigned to Advisory Firm");
                        this.firmProductTypes.push(response.data);
                        this.firmProductType = response.data;
                    })
                    .catch(err => {
                        toastr.error("Product Type has not been assigned to Manager. " + err.data);
                    });
            }
            else {
                toastr.warning("Product type has been already registred");
            }
        };


        chechForDuplicateProductTypes(firmProductType: domains.IAdvisoryFirmProductType): boolean {
            let exist: boolean = false;
            for (let i = 0; i < this.firmProductTypes.length; i++) {
                if ((this.firmProductTypes[i].managerId == firmProductType.managerId) && (this.firmProductTypes[i].productTypeId == firmProductType.productTypeId) && (this.firmProductTypes[i].managerProductTypeId == firmProductType.managerProductTypeId))
                    exist = true;
            }
            return exist;
        };
        
        updateFirmProductType(): void {
            this.servicerService.updateAdvisoryFirmProductType(this.firmProductType)
                .then(response => {
                    toastr.success("Product Type assignment has been updated successfully.");
                    this.firmProductType = response.data;
                    this.cancel();
                    this.loadFirmProductTypes(this.advisoryFirmId);
                }, err => toastr.error("Unable to change Product Type Contact details. " + err.data) );
        };

        deleteFirmProductType(firmProductType: domains.IAdvisoryFirmProductType): void
        {
            if (!window.confirm("Are you sure ?"))
                return;

            this.servicerService.deleteAdvisoryFirmProductType(firmProductType.id)
                .then((response) => {
                    var ind = this.firmProductTypes.indexOf(firmProductType);
                    if (ind >= 0) {
                        this.firmProductTypes.splice(ind, 1);
                    }
                    toastr.success("Manager Product Type has been successfully unassigned");
                }, err => toastr.error("Manager Product Type has not been deleted. " + err.data));
        };

        // #endregion Product Type CRUD
        
        $onInit(): void {
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "advisoryFirmId" || key === "reload") {
                    if (this.advisoryFirmId > 0) {
                        this.loadAdvisoryFirmManagers();
                        this.loadFirmProductTypes(this.advisoryFirmId);
                    }
                }
            }
        }
    }


    class CuFirmProductTypes implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                managerId: "<",
                advisoryFirmId: "<",
                reload: "<"
            };
            this.controller = CuFirmProductTypesController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/cu-firm-product-types.html";
        }
    }
    angular.module(Constants.APP).component("cuFirmProductTypes", new CuFirmProductTypes());
}